import listViewStrings from './constants';
import type TableViewConversationRelation from 'mini-mail-list-store/lib/store/schema/TableViewConversationRelation';

/**
 * Utility function to tell whether a mail conversation is a meeting request or not
 * @param tableConversationRelation, which has the itemClasses to notify whether the mail item is a meeting request or not
 */
export default function doesConversationContainsMeeting(
    tableConversationRelation: TableViewConversationRelation
): boolean {
    return tableConversationRelation.itemClasses.indexOf(listViewStrings.meetingRequestClass) > -1;
}
